import { ContraseniaMantenientoComponent } from './contrasenia-mantenimiento.component';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MenuService } from './app.menu.service';
import { PrimeNGConfig } from 'primeng/api';
import { Router } from '@angular/router';
import { UsuarioService } from '@framework-seguridad/servicio/spring/seguridad/usuario.service';
import { AppConfig } from '@env/appconfig';
import { SeguridadUsuarioLogin } from '@framework/modelo/seguridad/SeguridadUsuarioLogin';
import { SeguridadUsuarioActual } from '@framework/modelo/seguridad/SeguridadUsuarioActual';
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { InteractionType } from '@azure/msal-browser';

@Component({
    selector: 'app-main',
    templateUrl: './app.main.component.html',
    styleUrls: ['./app.main.component.scss']
})
export class AppMainComponent implements OnInit {

    @ViewChild(ContraseniaMantenientoComponent, { static: false }) contraseniaMantenientoComponent: ContraseniaMantenientoComponent;

    menuMode = 'static';

    colorScheme = 'light';

    menuTheme = 'layout-sidebar-darkgray';

    overlayMenuActive: boolean;

    staticMenuDesktopInactive: boolean;

    staticMenuMobileActive: boolean;

    menuClick: boolean;

    search = false;

    searchClick = false;

    userMenuClick: boolean;

    topbarUserMenuActive: boolean;

    notificationMenuClick: boolean;

    topbarNotificationMenuActive: boolean;

    rightMenuClick: boolean;

    rightMenuActive: boolean;

    configActive: boolean;

    configClick: boolean;

    resetMenu: boolean;

    menuHoverActive = false;

    inputStyle = 'outlined';

    ripple: boolean;

    modules: any[] = []

    constructor(
        private authService: MsalService,
        @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
        private menuService: MenuService,
        private primengConfig: PrimeNGConfig,
        public usuarioService: UsuarioService,
        private config: AppConfig,
        private router: Router) {
    }

    ngOnInit() {
        this.primengConfig.ripple = true;
        this.menuClick = true;
        this.topbarUserMenuActive = false;
        this.topbarNotificationMenuActive = false;
        this.rightMenuActive = false;

        if (this.isOverlay()) {
            this.overlayMenuActive = !this.overlayMenuActive;
        }

        if (this.isDesktop()) {
            this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
        } else {
            this.staticMenuMobileActive = !this.staticMenuMobileActive;
            if (this.staticMenuMobileActive) {
                this.blockBodyScroll();
            } else {
                this.unblockBodyScroll();
            }
        }

        this.wf_getmodules()
        this.coreUsuario()
    }

    onLayoutClick() {
        if (!this.searchClick) {
            this.search = false;
        }

        if (!this.userMenuClick) {
            this.topbarUserMenuActive = false;
        }

        if (!this.notificationMenuClick) {
            this.topbarNotificationMenuActive = false;
        }

        if (!this.rightMenuClick) {
            this.rightMenuActive = false;
        }

        if (!this.menuClick) {
            if (this.isSlim()) {
                this.menuService.reset();
            }

            if (this.overlayMenuActive || this.staticMenuMobileActive) {
                this.hideOverlayMenu();
            }

            this.menuHoverActive = false;
            this.unblockBodyScroll();
        }

        if (this.configActive && !this.configClick) {
            this.configActive = false;
        }

        this.searchClick = false;
        this.configClick = false;
        this.userMenuClick = false;
        this.rightMenuClick = false;
        this.notificationMenuClick = false;
        this.menuClick = false;
    }

    onMenuButtonClick(event) {
        this.menuClick = true;
        this.topbarUserMenuActive = false;
        this.topbarNotificationMenuActive = false;
        this.rightMenuActive = false;

        if (this.isOverlay()) {
            this.overlayMenuActive = !this.overlayMenuActive;
        }

        if (this.isDesktop()) {
            this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
        } else {
            this.staticMenuMobileActive = !this.staticMenuMobileActive;
            if (this.staticMenuMobileActive) {
                this.blockBodyScroll();
            } else {
                this.unblockBodyScroll();
            }
        }

        event.preventDefault();
    }

    onSearchClick(event) {
        this.search = !this.search;
        this.searchClick = !this.searchClick;
    }

    onSearchHide(event) {
        this.search = false;
        this.searchClick = false;
    }

    onMenuClick($event) {
        this.menuClick = true;
        this.resetMenu = false;
    }

    onTopbarUserMenuButtonClick(event) {
        this.userMenuClick = true;
        this.topbarUserMenuActive = !this.topbarUserMenuActive;

        this.hideOverlayMenu();

        event.preventDefault();
    }

    onTopbarNotificationMenuButtonClick(event) {
        this.notificationMenuClick = true;
        this.topbarNotificationMenuActive = !this.topbarNotificationMenuActive;

        this.hideOverlayMenu();

        event.preventDefault();
    }

    onRightMenuClick(event) {
        localStorage.removeItem('access_token');
        localStorage.clear()
        sessionStorage.clear()
        this.router.navigate(['']);
        event.preventDefault();

    }

    onRippleChange(event) {
        this.ripple = event.checked;
    }

    onConfigClick(event) {
        this.configClick = true;
    }

    isSlim() {
        return this.menuMode === 'slim';
    }

    isOverlay() {
        return this.menuMode === 'overlay';
    }

    isDesktop() {
        return window.innerWidth > 991;
    }

    isMobile() {
        return window.innerWidth <= 991;
    }

    hideOverlayMenu() {
        this.overlayMenuActive = false;
        this.staticMenuMobileActive = false;
    }

    blockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.add('blocked-scroll');
        } else {
            document.body.className += ' blocked-scroll';
        }
    }

    unblockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        } else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
                'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    }

    cambiarclave() {
        this.usuarioService.obtenerUsuarioActual().then(
            resp => {
                this.contraseniaMantenientoComponent.iniciarComponente(resp.usuario, '');
            }
        );
    }
    coreBuscar(webLink) {
        if (localStorage.getItem('access_login') == null)
            this.coreSalir()
        else
            window.open(webLink, '_blank');
    }

    coreUsuario() {
        this.usuarioService.obtenerUsuarioActual().then(
            response => {
                localStorage.setItem('usuarioActual', JSON.stringify(response));
            }
        );
    }

    wf_getmodules() {
       this.modules=JSON.parse(sessionStorage.getItem('modules'))
    }

    coreSalir() {
        localStorage.removeItem('access_token');
        this.logout();
        //localStorage.clear()
        //sessionStorage.clear()
        //this.router.navigate(['']);
    }

    logout() {
        var loginDisplay = this.authService.instance.getAllAccounts().length > 0;
        if (loginDisplay) {
            if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
                this.authService.logoutPopup({
                    postLogoutRedirectUri: "/",
                    mainWindowRedirectUri: "/"
                });
            } else {
                this.authService.logoutRedirect({
                    postLogoutRedirectUri: "/",
                });
            }
        }
        else {
            this.router.navigate(['']);
        }
    }

}
